<template>
    <div class="online-help-page">
        <div class="online-help-page__shell">
            <div class="online-help-page__header">
                <div>
                    <span class="online-help-page__eyebrow">Assistance</span>
                    <h5 class="title online-help-page__title">
                        {{ $tl("labels.routes.onlineHelp") }}
                        <ShowNewBadgeDetails class="ms-2" badge_uuid="a644c6f5-8bc3-48e8-be08-124398dfa9e1" />
                    </h5>
                    <p class="online-help-page__subtitle">Accédez rapidement aux tutoriels disponibles pour vos modules.</p>
                </div>
            </div>

            <LoaderComponent class="mx-auto" v-if="loading" />
            <div v-else-if="modules.length > 0" class="online-help-page__grid">
                <article
                    v-for="module in modules"
                    :key="module"
                    class="online-help-module-card"
                    role="button"
                    tabindex="0"
                    @click="goToHelpForModule(module)"
                    @keydown.enter.prevent="goToHelpForModule(module)"
                    @keydown.space.prevent="goToHelpForModule(module)">
                    <div class="online-help-module-card__icon">
                        <feather :type="getModuleTypeIcon(module)" />
                    </div>
                    <div>
                        <span class="online-help-module-card__meta">Module</span>
                        <h6>{{ getModuleTypeLabel(module) }}</h6>
                    </div>
                    <feather type="chevron-right" class="online-help-module-card__arrow" />
                </article>
            </div>
            <div v-else class="online-help-page__empty">{{ $tl("labels.videos.empty") }}</div>
        </div>
    </div>
</template>
<script>
import LoaderComponent from "../../../components/LoaderComponent.vue";
import ModuleTypesEnum from "../../../mixins/enums/ModuleTypesEnum";
import ShowNewBadgeDetails from "../../../components/NewBadges/showNewBadgeDetails.vue";

export default {
    data() {
        return {
            loading: false,
            videosList: [],
        };
    },
    mixins: [ModuleTypesEnum],
    methods: {
        fetchVideos() {
            this.loading = true;

            axios
                .get("/api/videos")
                .then((response) => {
                    this.videosList = response.data.data;
                })
                .catch((error) => {
                    this.notifyError(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        goToHelpForModule(module) {
            this.$router.push({
                name: "online_help.module",
                params: { module },
            });
        },
    },
    computed: {
        modules() {
            return _.uniq(this.videosList.map((video) => video.module));
        },
    },
    components: {
        LoaderComponent,
        ShowNewBadgeDetails,
    },
    created() {
        this.fetchVideos();
    },
};
</script>

<style scoped>
.online-help-page {
    min-height: calc(100vh - 72px);
    padding: 28px 18px 40px;
    background: linear-gradient(180deg, #f7fbfc 0%, #eef8fa 100%);
}

.online-help-page__shell {
    max-width: 1080px;
    margin: 0 auto;
}

.online-help-page__header {
    margin-bottom: 18px;
}

.online-help-page__eyebrow {
    display: inline-flex;
    margin-bottom: 8px;
    color: var(--main-color-light, #30a4b7);
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.online-help-page__title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    color: #142f3c;
    font-size: 1.45rem;
    font-weight: 700;
}

.online-help-page__subtitle {
    max-width: 620px;
    margin: 8px 0 0;
    color: #6c7f88;
    line-height: 1.5;
}

.online-help-page__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
}

.online-help-module-card {
    position: relative;
    display: grid;
    grid-template-columns: 56px minmax(0, 1fr) 18px;
    gap: 14px;
    align-items: center;
    min-height: 96px;
    padding: 18px;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 18px 45px rgba(15, 58, 72, 0.07);
    cursor: pointer;
    transition:
        transform 0.18s ease,
        border-color 0.18s ease,
        box-shadow 0.18s ease;
}

.online-help-module-card:hover,
.online-help-module-card:focus {
    border-color: rgba(48, 164, 183, 0.28);
    box-shadow: 0 22px 54px rgba(15, 58, 72, 0.11);
    outline: none;
    transform: translateY(-2px);
}

.online-help-module-card__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    color: #fff;
    background: linear-gradient(145deg, #083e60, #0b5d87);
    border-radius: 14px;
    box-shadow: 0 12px 24px rgba(8, 62, 96, 0.16);
}

.online-help-module-card__icon .feather {
    width: 26px;
    height: 26px;
}

.online-help-module-card__meta {
    display: inline-flex;
    margin-bottom: 5px;
    color: var(--main-color-light, #30a4b7);
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.online-help-module-card h6 {
    margin: 0;
    overflow: hidden;
    color: #173746;
    font-size: 1rem;
    font-weight: 800;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.online-help-module-card__arrow {
    width: 18px;
    height: 18px;
    color: #98a2b3;
    transition:
        color 0.18s ease,
        transform 0.18s ease;
}

.online-help-module-card:hover .online-help-module-card__arrow {
    color: #083e60;
    transform: translateX(2px);
}

.online-help-page__empty {
    padding: 34px 20px;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 18px;
    color: #6c7f88;
    text-align: center;
    background: #fff;
    box-shadow: 0 18px 45px rgba(15, 58, 72, 0.07);
}

@media (max-width: 991.98px) {
    .online-help-page__grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 767.98px) {
    .online-help-page {
        padding: 20px 12px 32px;
    }

    .online-help-page__grid {
        grid-template-columns: 1fr;
    }
}
</style>
